<template>
    <div>
        <a-row :gutter="24" type="flex">
            <a-col :span="24" class="mb-24">
                <a-card :bordered="false" class="header-solid h-full" :bodyStyle="{ padding: 0 }">
                    <template #title>
                        <a-row type="flex" align="middle">
                            <a-col :span="24" :md="12">
                                <h5 class="font-semibold m-0">  درخواست های بنر  </h5>
                            </a-col>
                            <a-col :span="24" :md="12"
                                style="
                    display: flex;
                    align-items: center;
                    justify-content: flex-end;
                  ">
                                <a-button class="btn-outline-purple" icon="search" @click="isHidden = !isHidden">
                                    جستجو
                                </a-button>
                                &nbsp;
                            </a-col>
                        </a-row>
                    </template>

                    <b-card style="margin:20px; !important ; border:none;" v-if="isHidden">
                            <a-col style="margin-top: 20px" :md="3">
                                <a-button class="btn-outline-green w-100" icon="search" @click="getData">
                                    جستجو
                                </a-button>

                            </a-col>
                           <div class="row">
                           
                            <div class="col-md-6 my-1">
                                 <UserSearch @ids="getIds" />

                            </div>
                            
                             <div class="col-md-6 my-1">
                                <label class="sr-only" for="inline-form-input-name"> وضعیت درخواست</label>
                                <select class="form-control" v-model="search.status">
                                    <option value="">انتخاب</option>
                                    <option value="pending"> درانتظار</option>
                                    <option value="success">قبول شده</option>
                                    <option value="denied">رد شده </option>
                                </select>
                            </div>
                          </div>
                           
                    </b-card>
                    <a-row style="justify-content: center; display: flex" v-if="$store.state.loading">
                        <template>
                            <div>
                                <a-spin />
                            </div>
                        </template>
                    </a-row>
                    <div v-else>
                        <section class="w-100 p-4 text-center">
                            <table class="table table-hover">
                                <thead>
                                    <tr>
                                        <th scope="col">شناسه</th>
                                        <th scope="col">کاربر</th>
                                        <th scope="col"> وضعیت</th>
                                        <th scope="col"> از تاریخ</th>
                                        <th scope="col"> تا تاریخ</th>
                                        <th scope="col"> مشاهده</th>

                             
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr v-for="row in data">
                                        <th scope="row">#{{ row.id }}</th>
                                        <th>{{row.user ?  $root.full_name(row . user . firstname , row . user . lastname) : '' }}</th>
                                     
                                        <td>
                                       
                                            <b-badge pill v-if="row.status == 'success'" variant="info" class="bg-success">
                                                {{row.status}}
                                            </b-badge>
                                             <b-badge pill v-else-if="row.status == 'pending'" variant="warning" class="bg-warning">
                                               {{ row.status }}
                                            </b-badge>
                                             <b-badge pill v-else variant="danger" class="bg-danger">
                                               {{ row.status }}
                                            </b-badge>
                                        </td>
                                        <td>
                                           
                                            {{ row . start_date != null ? new Date(row . start_date) . toLocaleDateString('fa-IR') : '-' }}

                                        </td>
                                        <td>
                                           
                                            {{ row . end_date != null ? new Date(row . end_date) . toLocaleDateString('fa-IR') : '-' }}

                                        </td>
                                         <td>
                                            <div class="d-flex">
                                            <ModalShow @getData="getData" :info="row" />                                          
                                            &nbsp;   
                                             <a-button class="btn-outline-danger" shape="square" icon="delete"
                                                    @click="deleteRow(`banner-request/delete/${row.id}`)" v-show="$root.hasPermission('/requests/delete/')"></a-button>
                                            
    
                                           </div>

                                        </td>
                                    </tr>
                                        
                                    </tr>
                                </tbody>
                            </table>
                        </section>
                        <a-row class="pagination">
                            <a-pagination :total="total" :item-render="$root.itemRender"
                                @change="getData(currentPage)" v-model="currentPage" />
                        </a-row>
                    </div>
                </a-card>
            </a-col>
        </a-row>
    </div>
</template>
<script>
    import ModalShow from "../../components/Requests/ModalBanner.vue"
        import UserSearch from "../../components/Blocks/UserSelectMultiple.vue"


    export default {
        components: {
            ModalShow,
            UserSearch
        },
        data() {
            return {
                data: [],
                users: [],
                currentPage: 1,
                total: 0,
                isHidden: false,
                search: {
                    status: "",
                    user_id: [],
                },
            };
        },
        methods: {
            getIds(value) {
                this.search.user_id=value
            },
            async getData() {
                let _this = this;
                this.$store.state.loading = true;
                let url =
                    `/banner-request?page=${this.currentPage}&&status=${this.search.status}&&user_id=${this.search.user_id}`;
                await axios
                    .get(url)
                    .then(function(response) {
                        _this.data = response.data.data;
                        _this.$store.state.loading = false;
                        _this.total = response.data.total;
                        _this.currentPage = response.data.current_page;
                    })
                    .catch(function(err) {
                        _this.$root.handleAxiosError(err);
                    });
            },
           
             deleteRow(url) {
                this.$swal({
                    title: "آیا از حذف اطلاعات اطمینان دارید؟",
                    showDenyButton: true,
                    showCancelButton: false,
                    confirmButtonText: "بله",
                    denyButtonText: "لغو",
                }).then((result) => {
                    if (result.isConfirmed) {
                        let _this = this;
                        axios
                            .get(url)
                            .then(function(response) {
                                _this.$toast.success("با موفقیت حذف شد.");
                                _this.getData();
                            })
                            .catch(function(err) {
                                _this.$root.handleAxiosError(err);
                            });
                    }
                });
            },
        },
        mounted() {
            this.getData();
        },
    };
</script>

<style scope>
    .pagination {
        display: flex;
        justify-content: center;
        margin: 15px;
    }
</style>
